import cn from 'classnames'
import Link from 'next/link'
import React from 'react'

import { EventListItem } from './EventListItem/EventListItem'

export interface EventListItemProps {
  title: string
  logo: string
  description: string
  date: string
  updated_at: string
  city: string
  country: string
  className?: string
  slug: string
}
export interface EventListProps {
  post: EventListItemProps[]
  className?: string
}
export const EventList: React.FC<EventListProps> = ({ post, className = '' }) => {
  const data = post

  return (
    <div className={cn(className, 'bg-white', 'border-y', 'border-zinc-300')}>
      <ul className="divide-y divide-zinc-300">
        {data.map((item: EventListItemProps, index: number) => {
          return (
            <li key={index}>
              <Link href={'/event/' + item.slug}>
                <EventListItem
                  title={item.title}
                  logo={item.logo}
                  description={item.description}
                  date={item.date}
                  updated_at={item.updated_at}
                  country={item.country}
                  city={item.city}
                />
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
